import { Component, OnInit } from '@angular/core';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/app-state';
import { ToastrService } from 'ngx-toastr';
import { CommerceService } from '../../../core/service/app/commerce.service';

@Component({
  selector: 'app-commerce-verification-form',
  templateUrl: './commerce-verification-form.component.html',
  styleUrls: ['./commerce-verification-form.component.scss']
})
export class CommerceVerificationFormComponent extends FormBaseComponent<any> implements OnInit {

  user;
  showWidget = false;
  isPerson = false;
  person: any;

  constructor(private commerceService: CommerceService, private store: Store<AppState>, private toastrService: ToastrService) {
    super();
    this.store.subscribe(state => {
      this.user = state.user.data ? state.user.data.email : '';
    })
    this.commerceService.dataSub.subscribe(x => {
      if (x.general) {
        if (x.general.personPhysical) {
          if (x.general.personPhysical.contact) {
            this.isPerson = x.general.personPhysical.contact.name ? x.general.personPhysical.contact.name.length > 0 : false;
          }
        }
      }
    })
  }

  ngOnInit() {
    this.init();
  }

  togglePaybook() {
    this.showWidget = !this.showWidget;
  }

  transaccions(data) {
    this.toastrService.success('Datos Obtenidos', 'Exito')
    this.showWidget = false;
  }

  completeBuro(data) {
    this.toastrService.success('Datos Guardados Correctamente', 'Exito')
    // if (!data.id) {
    //   this.toastrService.error('No se encontro la persona', 'Error')
    // } else {
    // }
  }

}



// WEBPACK FOOTER //
// ./src/app/form/form/commerce-verification-form/commerce-verification-form.component.ts